import Vue from 'vue'
import App from './App'
import router from './router'
// import store from './store'
// import 'lib-flexible/flexible'
import 'swiper/dist/css/swiper.css'
import api from './api'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import wx from 'weixin-js-sdk'

Vue.config.productionTip = false;
Vue.prototype.api = api;

Vue.prototype.err = e => window.alert(e.message);

Vue.prototype.$view = e => e > 9999 ? `${Math.round(e  / 1000) / 10}万` : e;

Vue.prototype.$duration = e => {
  const m = ~~(e / 1000 / 60), s = ~~(e / 1000 % 60);
  return `${m < 10 ? '0' + m : m}:${s < 10 ? '0' + s : s}`;
};

Vue.prototype.$time = e => {
  const now = ((new Date).getTime() - (new Date(e)).getTime()) / 1000;

  if (now >= 3600 && now < 86400) return `${~~(now / 3600)}小时前`;
  if (now >= 60 && now < 3600) return `${~~(now / 60)}分钟前`;
  if (now < 60) return '刚刚';
  return e.substr(0, 16);
};

Vue.prototype.$date = e => {
  const now = ((new Date).getTime() - (new Date(e)).getTime()) / 1000;

  if (now >= 3600 && now < 86400) return `${~~(now / 3600)}小时前`;
  if (now >= 60 && now < 3600) return `${~~(now / 60)}分钟前`;
  if (now < 60) return '刚刚';
  return e.substr(0, 10);
};

Vue.prototype.$share = (title = '', imgUrl = 'https://img.vhiphop.top/web/logo-icon.jpg') => {
  title = `${title ? title + '-' : ''}Vhiphop 唯舞`;
  document.title = title;
  const link = window.location.href;
  api.post('sign/wx', {link}).then(e => {
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: e.appId, // 必填，公众号的唯一标识
      timestamp: e.timestamp, // 必填，生成签名的时间戳
      nonceStr: e.nonceStr, // 必填，生成签名的随机串
      signature: e.signature,// 必填，签名
      jsApiList: [
        'updateAppMessageShareData',
        'updateTimelineShareData',
      ] // 必填，需要使用的JS接口列表
    });
    wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
      wx.updateAppMessageShareData({
        title, // 分享标题
        desc: '更多精彩，尽在 Vhiphop 唯舞。', // 分享描述
        link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl, // 分享图标
        success: function () {
          // 设置成功
        }
      });
      wx.updateTimelineShareData({
        title, // 分享标题
        link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl, // 分享图标
        success: function () {
          // 设置成功
        }
      });
    });
  }, e => console.log(e));
};

// Vue.prototype.wx = wx;
Vue.use(VueAwesomeSwiper);


/*router.afterEach((to, from) => {
  //to即将进入的目标路由对象，from当前导航正要离开的路由， next : 下一步执行的函数钩子
  const url = window.location.href;
  api.post('sign/wx', {url}).then(e => {
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: e.appId, // 必填，公众号的唯一标识
      timestamp: e.timestamp, // 必填，生成签名的时间戳
      nonceStr: e.nonceStr, // 必填，生成签名的随机串
      signature: e.signature,// 必填，签名
      jsApiList: [
          'updateAppMessageShareData',
          'updateTimelineShareData',
      ] // 必填，需要使用的JS接口列表
    });
    wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
      wx.updateAppMessageShareData({
        title: store.state.title, // 分享标题
        desc: '更多精彩，尽在 Vhiphop 唯舞', // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: store.state.cover, // 分享图标
        success: function () {
          // 设置成功
        }
      });
      wx.updateTimelineShareData({
        title: store.state.title, // 分享标题
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: store.state.cover, // 分享图标
        success: function () {
          // 设置成功
        }
      });
    });

  }, Vue.prototype.err);
});*/

new Vue({
  el: '#app',
  router,
  // store,
  components: { App },
  template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/main.js